import get from 'lodash/get';

import { DEFAULT_GROUP_LABEL, ADDED_GROUP_LABEL } from './constants';

export const hasAnyError = (errors, fieldPrefixOrKeys) => {
  if (Array.isArray(fieldPrefixOrKeys)) {
    return fieldPrefixOrKeys.some((key) => !!get(errors, key));
  }

  return !!get(errors, fieldPrefixOrKeys);
};

export const hasMetaErrors = (errors) => {
  if (!errors?.meta) return false;
  return errors.meta.some((metaError) => metaError
      && (metaError.key || metaError.type || metaError.operator || metaError.value),
  );
};

export const isValidMeta = (m) => m.key && m.value && m.type?.value && m.operator?.value;

export const addOption = ({
  createdOptions,
  newOption,
  groupLabel = ADDED_GROUP_LABEL,
}) => {
  const existingGroup = createdOptions.find((g) => g.label === groupLabel);

  if (existingGroup) {
    return createdOptions.map((group) => (group.label === groupLabel
      ? { ...group, options: [newOption, ...group.options] }
      : group),
    );
  }

  return [{ label: groupLabel, options: [newOption] }, ...createdOptions];
};

export const removeOption = ({
  createdOptions,
  newOption,
  groupLabel = ADDED_GROUP_LABEL,
}) => {
  return createdOptions
    .map((group) => (group.label === groupLabel
      ? {
        ...group,
        options: group.options.filter((opt) => opt.value !== newOption.value),
      }
      : group),
    )
    .filter((group) => group.options.length > 0);
};

export const isEqualValue = (a, b) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((val, idx) => val === b[idx]);
  }
  return a === b;
};

export const isSelected = (value, option, isMulti = true) => (isMulti
  ? Array.isArray(value) && value.some((v) => isEqualValue(v.value, option.value))
  : isEqualValue(value?.value, option.value));

export const toggleOption = (value, option, isMulti = true) => {
  const selected = isSelected(value, option, isMulti);

  if (isMulti) {
    return selected
      ? value.filter((v) => !isEqualValue(v.value, option.value))
      : [...value, option];
  }

  return selected ? null : option;
};

export const normalizeGroupedOptions = (options) => {
  return Array.isArray(options) && options.length > 0 && !options[0].options
    ? [{ label: DEFAULT_GROUP_LABEL, options }]
    : options;
};
